import { EdgePreviewProPlanChangeRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { PreviewProPlanChange } from '@/modules/auth/use-cases'

export function makePreviewProPlanChange(): PreviewProPlanChange {
  return new EdgePreviewProPlanChangeRepository(makeSupabaseEdgeHttpClient()).execute
}
